import { ReactComponent as VideoTrade } from 'assets/icons/icon-video-trade.svg';

export default VideoTrade;
